// paypal countries blocklist
export const PAYPAL_DISABLED_COUNTRY_LIST = 'web.payment.paypal.disabled.country.list';

// enable paypal payment method
export const ENABLE_PAYPAL_PAYMENT_METHOD = 'web.payment.paypal.enabled';
